export default {
  default: () => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m),
  onboarding: () => import("/opt/buildhome/repo/layouts/onboarding.vue").then(m => m.default || m)
}